/*
	Montos con separador de miles.

	En la ficha del alumno los saldos salian como "10500.00": sin separador, un
	numero de cinco cifras hay que leerlo contando digitos. Esteban lo pidio
	(2026-09-16) al revisar la ficha en el telefono.

	Se separan los miles y se dejan siempre dos decimales, que es como se leen las
	cifras de dinero en los tres paises donde opera la academia.
*/

export const montoBonito = (valor : any) : string =>
{
	const numero = Number(valor)

	if(!isFinite(numero))
	{
		return "0.00"
	}

	return numero.toLocaleString
	(
		"en-US",
		{minimumFractionDigits : 2, maximumFractionDigits : 2}
	)
}

export default montoBonito
